import { HttpInterceptorFn } from "@angular/common/http";

// WebKit drops multipart bodies proxied through the service worker, so uploads skip it.
export const serviceWorkerBypassInterceptor: HttpInterceptorFn = (req, next) =>
    req.body instanceof FormData ? next(req.clone({ setHeaders: { "ngsw-bypass": "true" } })) : next(req);
